exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n._attachment_0[data-v-41a46d17] {\r\n  display:inline-block;\r\n  max-width: 46.5vw;\r\n  max-height: 46.5vw;\r\n  min-width: 5vw;\r\n  min-height: 5vw;\n}\n._attachment_list[data-v-41a46d17] {\r\n  margin-bottom:10px;\r\n  background:#dfe6e63f;\r\n  height: 100px;\r\n  overflow: auto;\n}\n.upload_img[data-v-41a46d17] {\r\n  border:1px solid #dec5c5;\r\n  max-width: 46.5vw;\r\n  max-height: 46.5vw;\r\n  width: auto;\r\n  height: auto;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41a46d17","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mobile-ticket/MobileTicketUpload.vue
// module id = 605
// module chunks = 75